import { DI } from '../../../../apps/crossword-maker/src/shared/di';

export const AddCategoryToCrosswordBookWordUseCase = () => {
    const CrosswordBookRepository = DI.resolve('CrosswordBookRepository');

    return {
        async execute(wordId: string, categoryName: string) {
            return await CrosswordBookRepository.addCategoryToWordByValues(wordId, categoryName);
        }
    }
}
